var min = $('input[name="filter.v.price.gte"]').val();
if (min == ''){
	min = 0; 
}
var max = $('input[name="filter.v.price.lte"]').val();
if (max == ''){
 	max = $('input[name="filter.v.price.gte"]').attr('max');
}

var fixed_max = $('input[name="filter.v.price.gte"]').attr('max');
var parts = window.location.href.split('?')[0].split('/');
var lastSegment = parts.pop() || parts.pop();  // handle potential trailing slash
if ($('.filter-item.cat').length > 0){
  if ($('.filter-item.cat').children('.filter-cat').data('value') == lastSegment){
    $('.filter-item.cat').children('.filter-cat').data('value', lastSegment).prop('checked', true).attr('disabled', true);
  }  
}

$('.filter-item.cat').click(function(){
  var click_value = $(this).children('.filter-cat').data('value');
  var new_url = lastSegment.replace(lastSegment, click_value);
  if( !$(this).children('.filter-cat').is(':checked') ){
    window.location.href = new_url;
  }
});

$('.filter-cat').change(function() {
  if(this.checked) {
    var click_value = $(this).data('value');
    var new_url = lastSegment.replace(lastSegment, click_value);
      window.location.href = new_url;
  }
});

$('#flat-slider').slider({
  orientation: 'horizontal',
  range: true,
  animate: true,
  min: 0,
  max: Number(fixed_max),
  values: [Number(min),Number(max)],
  slide: function(event, ui) {
    if ((ui.values[1] - ui.values[0]) < 1) {
      return false;
    }
    
    $('input[name="filter.v.price.gte"]').val(ui.values[0])
    $('input[name="filter.v.price.lte"]').val(ui.values[1])
    window.location.href = window.location.href.split('?')[0]+'?filter.v.price.gte='+ui.values[0]+'&filter.v.price.lte='+ui.values[1]
    
  }
});


$('.nama-brand').on('click', function(){
    $('.nama-brand').removeClass('active');
  	$('.nama-brand[data-value=' + $(this).attr('data-value') + ']').addClass('active')
    $('.chart-detail').hide(500);
  	$('.chart-detail.' + $(this).attr('data-value')).show(500)
});

$('.chart-detail').hide(500)
$('.chart-detail.brand-Nike').show(500)   

$('.select-nike').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-Nike .kategori-sub').hide(500);
  	$('.brand-Nike .kategori-sub.'+valueSelected).show(500);
});

$('.select-jordan').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-Jordan .kategori-sub').hide(500);
  	$('.brand-Jordan .kategori-sub.'+valueSelected).show(500);
});

$('.select-adidas').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-Adidas .kategori-sub').hide(500);
  	$('.brand-Adidas .kategori-sub.'+valueSelected).show(500);
});

$('.select-new_balance').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-New_Balance .kategori-sub').hide(500);
  	$('.brand-New_Balance .kategori-sub.'+valueSelected).show(500);
});

$('.select-asics').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-Asics .kategori-sub').hide(500);
  	$('.brand-Asics .kategori-sub.'+valueSelected).show(500);
});

$('.select-vans').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-Vans .kategori-sub').hide(500);
  	$('.brand-Vans .kategori-sub.'+valueSelected).show(500);
});

$('.select-converse').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-Converse .kategori-sub').hide(500);
  	$('.brand-Converse .kategori-sub.'+valueSelected).show(500);
});

$('.select-puma').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-Puma .kategori-sub').hide(500);
  	$('.brand-Puma .kategori-sub.'+valueSelected).show(500);
});

$('.select-rebook').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-Reebook .kategori-sub').hide(500);
  	$('.brand-Reebook .kategori-sub.'+valueSelected).show(500);
});

$('.select-hoka_one_one').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-Hoka_One_One .kategori-sub').hide(500);
  	$('.brand-Hoka_One_One .kategori-sub.'+valueSelected).show(500);
});

$('.select-atmos').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-Atmos .kategori-sub').hide(500);
  	$('.brand-Atmos .kategori-sub.'+valueSelected).show(500);
});

$('.select-88rising').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-88Rising .kategori-sub').hide(500);
  	$('.brand-88Rising .kategori-sub.'+valueSelected).show(500);
});

$('.select-herschel').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-Herschel .kategori-sub').hide(500);
  	$('.brand-Herschel .kategori-sub.'+valueSelected).show(500);
});

$('.select-porter').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-Porter .kategori-sub').hide(500);
  	$('.brand-Porter .kategori-sub.'+valueSelected).show(500);
});

$('.select-bearbrick').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-Bearbrick .kategori-sub').hide(500);
  	$('.brand-Bearbrick .kategori-sub.'+valueSelected).show(500);
});

$('.select-carhartt').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-Carhartt .kategori-sub').hide(500);
  	$('.brand-Carhartt .kategori-sub.'+valueSelected).show(500);
});

$('.select-huf').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-Huf .kategori-sub').hide(500);
  	$('.brand-Huf .kategori-sub.'+valueSelected).show(500);
});

$('.select-the_north_face').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-The_North_Face .kategori-sub').hide(500);
  	$('.brand-The_North_Face .kategori-sub.'+valueSelected).show(500);
});

$('.select-jungles').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-Jungles .kategori-sub').hide(500);
  	$('.brand-Jungles .kategori-sub.'+valueSelected).show(500);
});

$('.select-babylon').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-Babylon .kategori-sub').hide(500);
  	$('.brand-Babylon .kategori-sub.'+valueSelected).show(500);
});

$('.select-domestik').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-Domestik .kategori-sub').hide(500);
  	$('.brand-Domestik .kategori-sub.'+valueSelected).show(500);
});

$('.select-g-shock').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-G-shock .kategori-sub').hide(500);
  	$('.brand-G-shock .kategori-sub.'+valueSelected).show(500);
});

$('.select-nothing').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-Nothing .kategori-sub').hide(500);
  	$('.brand-Nothing .kategori-sub.'+valueSelected).show(500);
});

$('.select-stance').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-Stance .kategori-sub').hide(500);
  	$('.brand-Stance .kategori-sub.'+valueSelected).show(500);
});

$('.select-crep_Protect').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
  
  	$('.brand-Crep_Protect .kategori-sub').hide(500);
  	$('.brand-Crep_Protect .kategori-sub.'+valueSelected).show(500);
});

if (window.location.href.includes('/account?view=edit')){
  $(`<a href="/account" style="display : block; margin-top : 1em;">&larr; Return to account page</a>`).insertAfter( ".form-vertical" );
}

if (window.location.href.includes('notify-me')){
  var cust_notify = $('.cust_email_notify').val();
  
  const formData = new FormData();
  formData.append('email_customer', cust_notify);
  
  $.ajax({
    type: "POST",
    url: 'http://bdd.services/notify_me/config/ambil_notify/atmos-indonesia.myshopify.com',
    data: formData,
    dataType: "text",
    cache: false,
    contentType: false,
    crossDomain:true,
    processData: false,
    success: function(response){
      $(".notify-table tbody").html(response);
    },
    error: function(response) {
      console.log(response)
    }
  });
}

var kolom_length = $('.kolom-produk').length;
if(kolom_length == 1){
	$('.kolom-produk').addClass('nambah-gede');
}
var announcement_height = $('#shopify-section-announcement').outerHeight();
$(window).scroll(function() {
  if ($(this).scrollTop() > announcement_height) {
      $('div#shopify-section-header').addClass('bdd-sticky')
      $('.cart-panel .footer-container').removeClass('cart-on-top')
      $('#toTop').show()
  } else {
    $('div#shopify-section-header').removeClass('bdd-sticky')
    $('.cart-panel .footer-container').addClass('cart-on-top')
    $('#toTop').hide()
  }
})

url = window.location.href;
is_product = url.match(/.*\/products\/.*/);
if (window.location.href.includes('collections')){
  if (is_product == null){
    document.querySelector('#SortBy').addEventListener('change', function() {
      const urlSearchParams = new URLSearchParams(window.location.search);

      urlSearchParams.set(this.name, this.value);

      window.location = `?${urlSearchParams}`;
    });

    $('.size-digit-kebawah').appendTo('.2digit_kebawah');
    $('.size-digit-keatas[data-sort-type=UK]').appendTo('.type-uk');
    $('.size-digit-keatas[data-sort-type=US]').appendTo('.type-us');
    $('.size-digit-keatas[data-sort-type=EUR]').appendTo('.type-eur');

    function sortEm(a,b){
      return parseInt($(a).attr('data-sort-nomor')) > parseInt($(b).attr('data-sort-nomor')) ? 1 : -1;
    }
    $('.type-uk li').sort(sortEm).prependTo($('.type-uk'));
    $('.type-us li').sort(sortEm).prependTo($('.type-us'));
    $('.type-eur li').sort(sortEm).prependTo($('.type-eur'));

    var announce_height = $('#shopify-section-announcement').outerHeight();
    var header_height = $('#shopify-section-header').outerHeight();
    var headerc_height = $('.collection-header').outerHeight();

    var hasil_gabungan = announce_height + headerc_height;
    var window_height = $(window).height();

    var hasil_final = window_height - header_height;
    var hasil_mobile_lebih = header_height + headerc_height;
    var hasil_mobile_kurang = announce_height + header_height + headerc_height;

    $('.filter-sticky .panel').css('top', hasil_mobile_kurang + 'px');

    $(window).scroll(function() {
      if ($(this).scrollTop() > hasil_gabungan) {
        $('.filter-sticky').addClass('is-sticky')
        $('.filter-sticky.is-sticky').css('max-height', hasil_final + 'px' );
        $('.filter-sticky.is-sticky').css('top', header_height + 'px' );
      } else {
        $('.filter-sticky').removeClass('is-sticky')
        $('.filter-sticky').css('max-height', 'inherit');
      }

      if ($(this).scrollTop() > announce_height) {
        $('.filter-sticky .panel').css('top', hasil_mobile_lebih + 'px');
      } else {
        $('.filter-sticky .panel').css('top', hasil_mobile_kurang + 'px');
      }
    })
  }
}